const fonts = {
  heading: "Poppins', sans-serif",
  body: "Poppins', sans-serif",
};

export default fonts;
